import { ListSacRequest } from 'domain/usecases/sacRequest/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteListSacRequest implements ListSacRequest {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListSacRequest.Model>;

  constructor(url: string, httClient: HttpClient<ListSacRequest.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (
    params: ListSacRequest.Params,
  ): Promise<ListSacRequest.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
